// src/pages/CentersPage.jsx
import React, { useEffect, useState } from "react";
import "../styles/centers.css";

/** Google Maps Embed API (place 모드)
 *  - placeId가 있으면 정확히 해당 장소 표시
 *  - 없으면 q(이름+주소)로 검색
 */
const MapEmbed = ({ q, placeId, zoom = 16 }) => {
  const key = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  const src = placeId
    ? `https://www.google.com/maps/embed/v1/place?key=${key}&q=place_id:${encodeURIComponent(placeId)}&zoom=${zoom}&language=ko`
    : `https://www.google.com/maps/embed/v1/place?key=${key}&q=${encodeURIComponent(q)}&zoom=${zoom}&language=ko`;

  return (
    <div className="map-wrap">
      <iframe
        title={`map-${placeId || q}`}
        className="map-embed"
        src={src}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
};

export default function CentersPage({ data: outerData }) {
  const [innerData, setInnerData] = useState(null);
  const data = outerData || innerData;

  useEffect(() => {
    if (outerData) return;
    (async () => {
      const res = await fetch("/content.json", { cache: "no-cache" });
      const json = await res.json();
      setInnerData(json);
    })().catch(console.error);
  }, [outerData]);

  if (!data) return null;

  // ✅ 전역 핀 이미지 경로 (icons.pin 또는 centersPin 지원, 없으면 이모지 폴백)
  const pinSrc = data?.icons?.pin || data?.centersPin || null;

  // content.json에 centers가 없을 때 사용할 기본 값
  const centers = data?.centers || [
    {
      name: "PSI OSLOB RESORT(세부PSI오슬롭리조트)",
      address: "psi scuba diving resort, Oslob, 6025 Cebu, 필리핀",
      phone: "+639274239000",
    },
    {
      name: "Oceanplayer Dive(오션플레이어보홀센터)",
      address: "Lag-itan, Panglao, Bohol, 필리핀",
      phone: "+639817956569",
    },
    {
      name: "MJ Jeju DivingClub(MJ제주다이빙클럽)",
      address: "제주특별자치도 서귀포시 동백로, 태평로 119-1 107호",
      phone: "+821044643216",
    },
  ];

  return (
    <div className="centers-page">
      {/* ✅ 히어로/탭은 AboutLayout이 렌더링하므로 여기선 제외 */}

      {/* 리스트 */}
      <section className="centers-section">
        <div className="container">
          <header className="centers-header">
            <h2>협력센터</h2>
            <p>다이빙이지는 국내·외 협력센터와 연계하여 최적의 서비스를 제공하고 있습니다.</p>
          </header>

          <div className="centers-list">
            {centers.map((c, i) => (
              <article key={i} className="center-row">
                {/* 정보 */}
                <div className="center-info">
                  <h3 className="center-name">
                    <span className="pin" aria-hidden="true">
                      {pinSrc ? (
                        <img
                          src={pinSrc}
                          alt=""
                          className="pin-img"
                          loading="lazy"
                          width="18"
                          height="18"
                        />
                      ) : (
                        "📍"
                      )}
                    </span>
                    {c.name}
                  </h3>
                  <p className="center-address">{c.address}</p>
                  {c.phone && <p className="center-phone">{c.phone}</p>}
                </div>

                {/* 지도 */}
                <div className="center-map">
                  <MapEmbed placeId={c.placeId} q={`${c.name} ${c.address}`} zoom={16} />
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
